import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Register from './Register';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [showRegister, setShowRegister] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setError('');
            setSuccess('');
            setLoading(true);
            await login(email, password);
            // Auth state change is handled by onAuthStateChanged in AuthContext
        } catch (err) {
            setError('Login failed. Please check your credentials and try again.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setSuccess('Please contact your administrator to reset your password.');
        setShowForgotPassword(false);
    };

    if (showRegister) {
        return <Register onBackToLogin={() => setShowRegister(false)} />;
    }

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h2>SWAMED Dashboard</h2>
                    <p>{showForgotPassword ? 'Reset your password' : 'Sign in to access the management panel'}</p>
                </div>

                {error && <div className="login-error">{error}</div>}
                {success && <div className="login-success">{success}</div>}

                {showForgotPassword ? (
                    <form onSubmit={handleForgotPassword} className="login-form">
                        <div className="form-group">
                            <label htmlFor="email">Email Address</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="example@email.com"
                                required
                            />
                        </div>

                        <button type="submit" disabled={loading} className="btn-login">
                            {loading ? 'Sending...' : 'Send Password Reset Link'}
                        </button>

                        <button
                            type="button"
                            onClick={() => { setShowForgotPassword(false); setError(''); setSuccess(''); }}
                            className="btn-back"
                            style={{
                                marginTop: '12px',
                                background: 'transparent',
                                border: '1px solid #ccc',
                                color: '#666',
                                cursor: 'pointer',
                                padding: '12px',
                                borderRadius: '8px',
                                width: '100%'
                            }}
                        >
                            Back to Sign In
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="form-group">
                            <label htmlFor="email">Email Address</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="admin@swamed.com"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                            />
                        </div>

                        <div style={{ textAlign: 'right', marginBottom: '12px' }}>
                            <button
                                type="button"
                                onClick={() => { setShowForgotPassword(true); setError(''); setSuccess(''); }}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#10b981',
                                    cursor: 'pointer',
                                    fontSize: '0.9rem',
                                    padding: 0
                                }}
                            >
                                Forgot Password
                            </button>
                        </div>

                        <button type="submit" disabled={loading} className="btn-login">
                            {loading ? 'Signing in...' : 'Sign In'}
                        </button>
                    </form>
                )}

                <div className="login-footer">
                    <p>
                        Don't have an account?{' '}
                        <button
                            type="button"
                            onClick={() => setShowRegister(true)}
                            className="link-button"
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#10b981',
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                padding: 0
                            }}
                        >
                            Register
                        </button>
                    </p>
                    <p style={{ marginTop: '10px', fontSize: '0.85rem' }}>&copy; 2026 SWAMED Precision Agriculture. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default Login;

